import { Inject, Injectable } from '@angular/core';
import { ENV, NYDUS_NETWORK_API_BASE_URL } from '@rd/core/tokens/rd-lib.token';
import { EnvironmentType } from 'global-types';

// On wrapping Inject(ENV):
// This really doesn't affect development/production. Injecting `EnvService` is the same as injecting `env`.
// The issue is for Jest test environment, like this:
// TestBed.configureTestingModule({
//     providers: [
//         {provide: env, useValue: 'development' }
//     ]
// });
//
// 'development' gets locked in after we call `compileComponents` or `TestBed.inject(ENV)`.
// See https://stackoverflow.com/a/59790277/848915
//
// If we do something like this:
//
// TestBed.configureTestingModule({
//     providers: [
//         {provide: EnvService, useValue: MockEnvService }
//     ]
// });
//
// We can more flexibly change our tests like so:
// it('should contain TCv2 if env is not production', () => {
//   envService.env = 'development';
//   ... add tests here for env === 'development'
//   envService.env = 'production';
//   ... add tests here for env === 'production'

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  constructor(
    @Inject(ENV) public env: EnvironmentType,
    @Inject(NYDUS_NETWORK_API_BASE_URL)
    private nydusNetworkApiBaseUrl: string,
  ) {}

  get isDevelopment(): boolean {
    return this.env === 'local';
  }

  get isProduction(): boolean {
    return this.env === 'production';
  }

  get isStaging(): boolean {
    return this.env === 'staging';
  }

  get isUat(): boolean {
    return this.nydusNetworkApiBaseUrl.includes('uat');
  }

  shouldOverrideServerFlag(cosntraintKey: string): boolean {
    return !this.isProduction && !!localStorage.getItem(cosntraintKey);
  }
}
